import mapper from 'object-mapper';
import { add } from '@/Libs/Decimal';

export default (data, shop_id) => {
  const sheet1 = Object.keys(data)[0];
  const r = mapper(data[sheet1], {
    '[].订单号': {
      'key': '[].ordersn',
    },
    '[].下单时间': [{ 'key': '[].created' }, { 'key': '[].orders_info[0].booking_date' }],
    '[].订单总金额': [
      { 'key': '[].total_fee' },
      { 'key': '[].transaction_amount' },
      { 'key': '[].orders_info[0].payment' },
      { 'key': '[].orders_info[0].transaction_amount' },
    ],
    '[].备注（客人订单可见）': [
      { 'key': '[].remark' },
      { 'key': '[].orders_info[0].order_remarks' },
    ],
    '[].备注（供应商可见）': [{ 'key': '[].web_remark' }],
    '[].联系人': {
      'key': '[].name',
    },
    '[].联系人电话': {
      'key': '[].phone',
    },
    '[].预订渠道': {
      'key': '[].shop_source',
    },
    '[].取消原因': {
      'key': '[].cancel_reason',
    },
    '[].产品类型': {
      'key': '[].type',
    },
    '[].出发地': [{ 'key': '[].departure' }, { 'key': '[].orders_info[0].departure' }],
    '[].目的地': [{ 'key': '[].destination' }, { 'key': '[].orders_info[0].destination_name' }],
    '[].订单状态': {
      'key': '[].orders_info[0].status_text',
      'default': 0,
    },
    '[].产品名称': {
      'key': '[].orders_info[0].product_name',
    },
    '[].出游日期/类型': {
      'key': '[].orders_info[0].departure_date',
    },
    '[].成人数': {
      'key': '[].orders_info[0].adult_num',
    },
    '[].儿童数': {
      'key': '[].orders_info[0].child_num',
    },
    '[].其它数（门票类）': {
      'key': '[].orders_info[0].ticket_num',
    },
    '[].成人单价': {
      'key': '[].orders_info[0].adult_price',
    },
    '[].儿童单价': {
      'key': '[].orders_info[0].child_price',
    },
    '[].其它单价': {
      'key': '[].orders_info[0].ticket_price',
    },
    '[].房差（元）': {
      'key': '[].orders_info[0].diff_price',
    },
    '[].房间数': {
      'key': '[].orders_info[0].room_num',
    },
  }).map((item) => ({
    ...item,
    orders_info: item.orders_info.map((oi) => ({
      ...oi,
      num: add(Number(oi.adult_num), Number(oi.child_num)),
      order_types: 2,
    })),
    is_online: 0,
    pf_id: 7,
    shop_id: shop_id,
    order_types: 2,
  }));
  return r;
};
